import {
  usePeopleQuery,
  PeopleFilter,
  Person,
} from "@/features/people/graphql/generated";
import { isEmpty, isNil, omitBy } from "lodash";

export const usePeople = (filter?: PeopleFilter) => {
  const cleanFilter = omitBy(filter, isNil);
  const { data, loading } = usePeopleQuery({
    variables: {
      filter: cleanFilter,
    },
    skip: isEmpty(cleanFilter),
  });

  const people = (data?.people || []) as Person[];

  return {
    people,
    loading,
  };
};
